import { Box, Container, Typography } from '@mui/material'
import { PublicationImageCard } from '../../../../../../shared-components/card/PublicationImageCard'
import styles from './ImagesLicensingList.module.scss'
import { useEffect, useState } from 'react'
import instance from '../../../../../../../providers/axios.config'
import Notiflix from 'notiflix'
import { monthsBetweenDates } from '../../../../../../../utils/helpers'
import moment from 'moment/moment'
import { CustomPagination } from '../../../../../../shared-components/pagination/CustomPagination'
import SkeletonImageWithPagination from '../../../../../../shared-components/skeleton/imageWithPagination'
import { useTranslation } from 'react-i18next'
import { typeResponse } from '../../../../../../../utils/types'

type imageProps = {
  thumbURL: string,
  id: string | number,
  createdAt: moment.Moment,
  height?: number;
  width?: number;
}

interface IProps {
  handleOpenDetails?: any
}
interface IResponse extends typeResponse{
  data:{
    images: imageProps[],
    pagination: {
      currentPage: number,
      perPage: number,
      totalPages: number
    }
  }
}

export const ImagesLicensingList = (props: IProps) => {
  const { handleOpenDetails } = props;
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 30,
    totalPages: 1
  })
  const [licensingImages, setLicensingImages] = useState<imageProps[]>([])

  const getLicensingImages = async () => {
    setIsLoading(true)
    try {
      const res = await instance.get(`seller/images/licensing?limit=${pagination.perPage}&page=${pagination.currentPage}`) as IResponse
      setLicensingImages(res?.data?.images || [])
      setPagination({ ...res?.data?.pagination })
      setIsLoading(false)
    } catch (error) {
      // Show error notification
      Notiflix.Report.failure(
        'Error',
        'Failed to fetch data. Please try again later.',
        'OK'
      )
    }
  }

  useEffect(() => {
    getLicensingImages()
  }, [pagination?.currentPage])

  const handleChange = (event: any, value: number) => {
    setPagination({ ...pagination, currentPage: value })
  }
  return (
    <Container maxWidth={false}>
      <Box className={styles.container}>
        {!isLoading && !licensingImages?.length ? <><Typography>{t('no_images_licensing')}</Typography></> : null}
        {isLoading ? <SkeletonImageWithPagination /> : <>
          {licensingImages.map((item: imageProps, index) => (
            <PublicationImageCard
              key={index}
              height={item?.height}
              isLoading={isLoading}
              imageId={item?.id}
              image={item?.thumbURL}
              canBeDeleted={monthsBetweenDates(moment(item?.createdAt), moment()) >= 6}
              handleOpenDetails={handleOpenDetails}
            />
          ))}
        </>}
      </Box>
      <Box>
        {pagination?.totalPages > 1 && <CustomPagination
          shape='rounded'
          count={pagination?.totalPages}
          page={pagination?.currentPage}
          onChange={handleChange}
          size='large'
          className={styles.pagination}
        />}
      </Box>
    </Container>
  )
}
